export default __webpack_public_path__ + "static/media/decor3.03708721.webp";